import { FC } from 'react'
import { useAppSelector } from '../../../store/hooks'
import { selectLoginChallenge } from '../../../store/auth/authSlice'
import { useCompanySso } from '../../../common/companySso'
import { InviteContext } from '../../../api/auth'
import { LoginHeader } from './LoginHeader'
import { SignupHeader } from './SignupHeader'

export interface SignUpViewHeaderProps {
  inviteContext?: InviteContext
  inviteContextLoading: boolean
}

export const SignUpViewHeader: FC<SignUpViewHeaderProps> = ({ inviteContext, inviteContextLoading }) => {
  const loginChallenge = useAppSelector(selectLoginChallenge)
  const { shouldUseCompanySso } = useCompanySso()

  if (loginChallenge) {
    return <SignupHeader hideAccountCreation />
  }
  if (inviteContext || inviteContextLoading) {
    return <SignupHeader hideAccountCreation className='justify-content-center' />
  }
  return <LoginHeader hideLoginOption={shouldUseCompanySso()} />
}
